import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import { Button } from 'antd';
import styles from "@/styles/article/return-policy.module.scss"
import Link from 'next/link'
export default function PrivacyStatement() {

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={styles['content-title']}>Privacy Policy</div>
            
            <div className={`${styles['ask-title']} padding-top-24`}>Effective Date: 18/05/2017</div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Introduction to our Privacy Policy
            </div>
            <div className={styles['answer-desc']}>
              This web site is subject to the National Privacy Principles under the Australian Privacy Act 1988 (as amended by the Privacy Amendment (Private Sector) Act 2000).This privacy policy applies to www.crazysales.com.au owned and operated by Crazy Sales. This Privacy policy explains in general terms how &quot;Crazy Sales&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; protects the privacy of your personal information under the National Privacy Principles. It will apply to any personal information you provide to us when registering with us on our Web site 
              <Link
                href="https://www.crazysales.com.au/"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  &nbsp;www.crazysales.com.au&nbsp;
                </a>
              </Link>
              . It also describes the choices available to you regarding our use of your personal information and how you can access and update this information.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              What Information Do We Collect?
            </div>
            <div className={styles['answer-desc']}>
              The types of personal information that we collect from you will depend on the circumstances of collection and on the type of service you request from us. For example, when you wish to purchase a product from this website we may collect details such as your name, address, delivery address, telephone numbers, gender and other information relevant to your purchase.
            </div>
            <div className={styles['answer-desc']}>
              As we are required by law to obtain your consent to the collection of &quot;sensitive information&quot; , we will assume that you have given consent to the collection of all information you have provided to us for use in accordance with this Statement, unless you tell us otherwise.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Third Party E-Commerce Solutions Provider
            </div>
            <div className={styles['answer-desc']}>
              Our shopping cart is hosted by our e-commerce solutions provider. They host our ordering system, and collect your billing information directly from you for the purpose of processing your order. This company does not use this information for any other purpose.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              How We Collect Information
            </div>
            <div className={styles['answer-desc']}>
              We may collect personal information about you when you visit our website, when you deal with us over the telephone, send us correspondence (whether by letter, fax or email), or when you have contact with us in person. We will not collect any personal information without your consent. We consider that your consent is granted when you complete the fields necessary to facilitate a transaction through this website.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              How We Use Your Personal Information
            </div>
            <div className={styles['answer-desc']}>
              We generally collect your personal information for the following purposes:
            </div>
            <div className={styles['answer-desc']}>
              To facilitate your access to our website, products and services
            </div>
            <div className={styles['answer-desc']}>
              To deliver products you have ordered from us
            </div>
            <div className={styles['answer-desc']}>
              To conduct marketing activities
            </div>
            <div className={styles['answer-desc']}>
              To provide you with information about our products and services
            </div>
            <div className={styles['answer-desc']}>
              To seek your opinion on our products, services, marketing and website.
            </div>
            <div className={styles['answer-desc']}>
              To send you newsletters
            </div>
            <div className={styles['answer-desc']}>
              Some of the personal information we collect is essential for us to be able to accurately identify who is using the service.
            </div>
            <div className={styles['answer-desc']}>
              Other types of personal information we collect help us to develop a profile of who is using our service and what their interests are.
            </div>
            <div className={styles['answer-desc']}>
              This assists us in offering products to suit the needs of the users of this website.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Disclosure of Personal Information to Third Parties
            </div>
            <div className={styles['answer-desc']}>
              We will share your personal information with third parties only in the ways that are described in this privacy policy.
            </div>
            <div className={styles['answer-desc']}>
              We may disclose your personal information to third parties for the purpose of which the information was collected, or for related purposes. For example to complete a transaction on your behalf or provide you with a product that you purchased.
            </div>
            <div className={styles['answer-desc']}>
              We engage third party contractors to perform services for us which involve the contractor handling personal information we hold. For example, we currently engage third party contractors to:
            </div>
            <div className={styles['answer-desc']}>
              Deliver products purchased from this website
            </div>
            <div className={styles['answer-desc']}>
              Provide electronic funds transfer services, credit card account processing and related services
            </div>
            <div className={styles['answer-desc']}>
              In these situations, the third party contractor is strictly prohibited from using any personal information about you outside of the specific purpose for which we have supplied it.
            </div>
            <div className={styles['answer-desc']}>
              In certain situations, Crazy Sales may be required to disclose personal data in response to lawful requests by public authorities, including to meet national security or law enforcement requirements.
            </div>
            <div className={styles['answer-desc']}>
              We may also disclose your personal information to various law enforcement agencies and governments around the world for security, to comply with a subpoena or other legal process, customs and immigration purposes. Other than the above, we will not disclose your personal information without your consent unless disclosure is either necessary to prevent a threat to life or health, authorised or required by law, reasonably necessary to enforce the law or necessary to investigate any suspected unlawful activity.
            </div>
            <div className={styles['answer-desc']}>
              If Crazy Sales is involved in a merger, acquisition, or sale of all or a portion of its assets, you will be notified via email and/or a prominent notice on our Web site of any change in ownership or uses of your personal information, as well as any choices you may have regarding your personal information.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Access & Correction of Information About You
            </div>
            <div className={styles['answer-desc']}>
              We will, on request, provide you with access to the information we hold about you, unless there is an exception which applies under the National Privacy Principles, including for the purposes of correcting or updating that information. We may recover from you our reasonable cost of supplying you with access to this information. Your request to provide access to this information will be dealt with within in a reasonable time. If we refuse to provide you with access to the information, we will provide you with reasons for the refusal and inform you of any exceptions relied upon under the National Privacy Principles.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Keeping Your Personal Information Up To Date
            </div>
            <div className={styles['answer-desc']}>
              We take reasonable steps to ensure that your personal information is accurate, complete, and up-to-date whenever we collect or use it. If the personal information we hold about you is inaccurate, incomplete or out-of-date, please contact us and we will take reasonable steps to either correct this information, or if necessary, discuss alternative action with you.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Updating/Accessing/Amending/Correcting Personal Information
            </div>
            <div className={styles['answer-desc']}>
              Crazy Sales will provide you with information about whether we hold any of your personal information. If your personal information changes, or if you no longer desire our service, you may delete, correct, or update it by accessing our member information page, by emailing our Customer Support at info@crazysales.com.au, or by contacting us by telephone or postal mail at the contact information listed below. We will respond to your request within a reasonable timeframe.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Choice/Opt-Out
            </div>
            <div className={styles['answer-desc']}>
              If you wish to subscribe to our newsletter(s), we will use your name and email address to send the newsletter to you. Out of respect for your privacy, you may choose to stop receiving our newsletters or marketing emails by filling in the 
              <Link
                href="https://www.crazysales.com.au/newsletters/frontpreunsub"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  Unsubscribe Form
                </a>
              </Link>
              , contacting us at 
              <a 
                className={styles['link']} 
                href="mailto:info@crazysales.com.au"
              >
                &nbsp;info@crazysales.com.au&nbsp;
              </a>
              or clicking an unsubscribe link that is included in each email.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Tracking Technologies
            </div>
            <div className={styles['answer-desc']}>
              Crazy Sales and its partners use cookies or similar technologies to analyze trends, administer the website, track users’ movements around the website, and to gather demographic information about our user base as a whole. You can control the use of cookies at the individual browser level, but if you choose to disable cookies, it may limit your use of certain features or functions on our website or service.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Log Files
            </div>
            <div className={styles['answer-desc']}>
              As is true of most web sites, we gather certain information automatically and store it in log files. This information may include internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and/or clickstream data. We do not link this automatically collected data to other information we collect about you.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Tell-A-Friend
            </div>
            <div className={styles['answer-desc']}>
              If you choose to use our referral service to tell a friend about our site, we will ask you for your friend&apos;s name and email address. We will automatically send your friend a one-time email inviting him or her to visit the site. Crazy Sales stores this information for the sole purpose of sending this one-time email and tracking the success of our referral program. Your friend may contact us at info@crazysales.com.au to request that we remove this information from our database.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Collection of 3rd Party PII
            </div>
            <div className={styles['answer-desc']}>
              You may also provide personal information about other people, such as their name, phone number and physical address. This information is only used for the sole purpose of completing your request or for whatever reason it may have been provided.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Links to Other Web Sites
            </div>
            <div className={styles['answer-desc']}>
              Our Site includes links to other Web sites whose privacy practices may differ from those of Crazy Sales. If you submit personal information to any of those sites, your information is governed by their privacy policies. We encourage you to carefully read the privacy policy of any Web site you visit.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Blogs
            </div>
            <div className={styles['answer-desc']}>
              Our Web site offers publicly accessible blogs or community forums. You should be aware that any information you provide in these areas may be read, collected, and used by others who access them. To request removal of your personal information from our blog or community forum, contact us at 
              <a 
                className={styles['link']} 
                href="mailto:info@crazysales.com.au"
              >
                &nbsp;info@crazysales.com.au&nbsp;
              </a>
              . In some cases, we may not be able to remove your personal information, in which case we will let you know if we are unable to do so and why.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Live Chat
            </div>
            <div className={styles['answer-desc']}>
              We may use a live chat feature to assist you with customer services. If our chat feature is offline we will collect your name and email address so that we may reply to your request. We will email you a full live chat history at end of live chat service.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Social Media Widgets
            </div>
            <div className={styles['answer-desc']}>
              Our Web site includes Social Media Features, such as the Facebook Like button, Google Plus, or Widgets, such as the Share this button or interactive mini-programs that may run on our site from time to time. These Features may collect your IP address, which page you are visiting on our site, and may set a cookie to enable the feature to function properly. Social media features and widgets are either hosted by a third party or hosted directly on our site. Your interactions with these features are governed by the privacy policy of the company providing it.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Surveys or Contests
            </div>
            <div className={styles['answer-desc']}>
              From time-to-time we may provide you the opportunity to participate in contests or surveys on our site. If you participate, we will request certain personal information from you. Participation in these surveys or contests is completely voluntary and you therefore have a choice whether or not to disclose this information. The requested information typically includes contact information (such as name and shipping address), and demographic information (such as post code).
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Security of Your Personal Information
            </div>
            <div className={styles['answer-desc']}>
              We will securely hold your personal information and we will not trade, rent or sell it.
            </div>
            <div className={styles['answer-desc']}>
              We will take all reasonable steps to keep secure any information which we hold about you. Personal information may be stored both electronically on our computer system, and in hard-copy form. Firewalls, SSL encryption, passwords, anti-virus software and email filters act to protect all our electronic information.
            </div>
            <div className={styles['answer-desc']}>
              The security of your personal information is important to us. When you enter sensitive information on our order forms, we encrypt the transmission of that information using secure socket layer technology (SSL).
            </div>
            <div className={styles['answer-desc']}>
              We follow generally accepted standards to protect the personal information submitted to us, both during transmission and once we receive it. No method of transmission over the Internet, or method of electronic storage, is 100% secure, however. Therefore, we cannot guarantee its absolute security. If you have any questions about security on our Web site, you can contact us at 
              <a 
                className={styles['link']} 
                href="mailto:info@crazysales.com.au"
              >
                &nbsp;info@crazysales.com.au
              </a>
            </div>
            <div className={styles['answer-desc']}>
              We take all necessary measures to ensure the security of hard-copy information.
            </div>
            <div className={styles['answer-desc']}>
              Once your transaction is finalised, both the electronic and hard-copy information are securely archived. After a period of 7 years, both the electronic and hard-copy information will be destroyed.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Data Retention
            </div>
            <div className={styles['answer-desc']}>
              If you wish to cancel your account or request that we no longer use your information to provide you services, contact us at 
              <a 
                className={styles['link']} 
                href="mailto:info@crazysales.com.au"
              >
                &nbsp;info@crazysales.com.au&nbsp;
              </a>
              . We will retain your information for as long as your account is active or as needed to provide you services. We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Resolving Your Concerns
            </div>
            <div className={styles['answer-desc']}>
              If you wish to gain access to your personal information, have a complaint about a breach of your privacy or you have any query on how your personal information is collected or used please forward your request, complaint or query to the address below. We will respond to your query or complaint as soon as possible.
            </div>
            <div className={styles['answer-desc']}>
              Email: info@crazysales.com.au
            </div>
            <div className={styles['answer-desc']}>
              Fax: (03) 9548 0779
            </div>
            <div className={styles['answer-desc']}>
              Post: The Privacy Officer, 2/5 Brear St, Springvale VIC 3171.
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Changes to This Privacy policy
            </div>
            <div className={styles['answer-desc']}>
              We may amend this Privacy policy as our business requirements or the law changes. Any changes to this Privacy policy will be updated on www.crazysales.com.au, so please visit this page periodically to ensure that you have our most current privacy policy.
            </div>
            <div className={styles['answer-desc']}>
              If we make any material changes we will notify by means of a notice on this Site prior to the change becoming effective.
            </div>

            <Button 
              type="primary"
              href="/"
              className={styles['continue-shopping-btn']}
            >
              Continue Shopping
            </Button>

          </div>
        </div>
      </DefaultLayout>
    </>
  )
}